// extracted by mini-css-extract-plugin
module.exports = {"button-container":"Button_button-container__qEZ80","button":"Button_button__C97FB","android":"Button_android__22fHr","apple":"Button_apple__tbbth"};